/* Prelaunch UI only. Native Shopify forms own consent, validation, CAPTCHA and success. */
(() => {
  'use strict';
  if (window.__oddLaunchReady) return;
  window.__oddLaunchReady = true;
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target || event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    const color = target.closest('[data-preview-color]');
    if (color) {
      const root = color.closest('[data-oc-product]');
      const stage = root?.querySelector('[data-oc-stage]');
      const slides = stage ? [...stage.querySelectorAll('.oc-media')] : [];
      const index = slides.findIndex(slide => slide.dataset.ocMediaId === color.dataset.previewMedia);
      if (!root || !stage || index < 0) return;
      event.preventDefault();
      color.closest('.oh12-color-values').querySelectorAll('a').forEach(link => {
        if (link === color) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current');
      });
      stage.scrollTo({ left: index * stage.clientWidth, behavior: 'instant' });
      stage.dispatchEvent(new Event('scroll'));
      root.dataset.featuredMedia = color.dataset.previewMedia;
      const price = root.querySelector('[data-preview-price-display]');
      if (price && color.dataset.previewPrice) price.textContent = color.dataset.previewPrice;
      const status = root.querySelector('[data-oc-status]');
      if (status) status.textContent = color.dataset.previewColor + ' view';
      const url = new URL(color.href, location.href);
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      if (url.origin === location.origin && /^https?:$/.test(location.protocol)) history.replaceState(history.state, '', url);
      return;
    }
    const updates = target.closest('[data-launch-updates]');
    if (updates) {
      const panel = document.getElementById('LaunchUpdates');
      if (!panel) return;
      event.preventDefault();
      panel.scrollIntoView({block:'start', behavior:'instant'});
      const heading = panel.querySelector('h2');
      heading?.focus({preventScroll:true});
    }
  });
})();
